"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IComponentModelResolutionResult.js.map